import type { RequestAccessPayload, RequestAccessResponse } from './types';

import { apiClient } from '@/shared/api/client';

export const requestAccess = (
  data: RequestAccessPayload
): Promise<RequestAccessResponse> =>
  apiClient.post<RequestAccessResponse>(
    '/api/v1/prospects/request-access',
    data
  );
